import { ThemeOptions } from '@mui/material';

export const baseTheme: ThemeOptions = {
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  },
  customLayout: {
    drawerWidth: 280,
    headerHeight: 56,
    mediumGap: 32,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
}; 